import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyAklDNZLY7yhNnXLsu8RY4ACoYJxbmWpwA",
    authDomain: "heart-breath-mind-webapp.firebaseapp.com",
    projectId: "heart-breath-mind-webapp",
    storageBucket: "heart-breath-mind-webapp.appspot.com",
    messagingSenderId: "681196095999",
    appId: "1:681196095999:web:a4934fdfe4798a117c3fca",
    measurementId: "G-62V3N5QHP3"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider, signInWithPopup, signOut };
